import QuickAddToCart from './QuickAddToCart';

export default QuickAddToCart;
